import { isEqual } from 'lodash';

import type {
  UserDropdownAllowedKeys,
  UserDropdownFlags,
  UserDropdownOrganization
} from 'types';

export const resetFlags = (items: Array<UserDropdownOrganization>, flag: UserDropdownFlags): Array<UserDropdownOrganization> => items.map(item => ({
  ...item,
  // $FlowIgnore - Cannot use flag [1] as a computed property. Computed properties may only be primitive literal values
  [flag]: false
}));

export const updateFlags = (
  items: Array<UserDropdownOrganization>,
  updatedItem: UserDropdownOrganization,
  flag: UserDropdownFlags
): Array<UserDropdownOrganization> => items.map(item => {
  if (isEqual(item, updatedItem)) {
    return {
      ...updatedItem,
      // $FlowIgnore - Cannot use flag [1] as a computed property. Computed properties may only be primitive literal values
      [flag]: true
    };
  }

  return {
    ...item,
    // $FlowIgnore - Cannot use flag [1] as a computed property. Computed properties may only be primitive literal values
    [flag]: false
  };
});

const getArrowDownIndex = (numItems: number, currentIndex: number): number => {
  const nextIndex = currentIndex + 1;

  if (nextIndex === numItems) {
    return 0;
  }

  return nextIndex;
};

const getArrowUpIndex = (numItems: number, currentIndex: number): number => {
  const nextIndex = currentIndex - 1;

  if (nextIndex < 0) {
    return numItems - 1;
  }

  return nextIndex;
};

export const getNextFocusedItemIndex = (
  numItems: number,
  currentIndex: number,
  keyPressed: UserDropdownAllowedKeys
): number => (keyPressed === 'ArrowDown'
  ? getArrowDownIndex(numItems, currentIndex)
  : getArrowUpIndex(numItems, currentIndex));
